import { Component, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { environment } from 'src/environments/environment';

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  dir: string;
  active?: boolean;
}

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnInit {
  lang;
  renderer: Renderer2;
  language: LanguageFlag;
  languages: LanguageFlag[] = [
    {
      lang: 'en',
      name: 'English',
      dir:'ltr',
      flag: './assets/media/svg/flags/226-united-states.svg',
    },
    {
      lang: 'ar',
      name: 'العربية',
      dir:'rtl',
      flag: './assets/media/svg/flags/158-egypt.svg',
    },
   
   
  ];
  constructor(
    private translationService: TranslationService,
    private router: Router,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
   }

  ngOnInit() {
    this.lang = this.translationService.getSelectedLanguage();
    this.setSelectedLanguage();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        this.setSelectedLanguage();
      });
  }

  setLanguageWithRefresh(lang) {
    this.setLanguage(lang);
    window.location.reload();
  }

  setLanguage(lang) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
        this.checkForDirectionChange();
        
      } else {
        language.active = false;
      }
    });
    this.translationService.setLanguage(lang);
  }
  checkForDirectionChange() {
    localStorage.setItem(environment.themeDirectionStorageKey, this.language.dir);
    this.renderer.setAttribute(document.documentElement, 'dir', this.language.dir);
  }
  setSelectedLanguage(): any {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }
}
